import Page from "core/Page";
import s from "underscore.string";
export default {
  /**
     }
     * detect IE
     * returns version of IE or false, if browser is not Internet Explorer
     * @param {String} userAgent A user agent string
     * @return {Boolean} True if running in some version of IE, otherwise false.
     */
  detectIE: function (userAgent) {
    if (userAgent) {
      var ua = userAgent;

      var msie = ua.indexOf("MSIE ");

      if (msie > 0) {
        // IE 10 or older => return version number
        return parseInt(ua.substring(msie + 5, ua.indexOf(".", msie)), 10);
      }

      var trident = ua.indexOf("Trident/");

      if (trident > 0) {
        // IE 11 => return version number
        var rv = ua.indexOf("rv:");

        return parseInt(ua.substring(rv + 3, ua.indexOf(".", rv)), 10);
      }

      var edge = ua.indexOf("Edge/");

      if (edge > 0) {
        return parseInt(ua.substring(edge + 5, ua.indexOf(".", edge)), 10);
      }
    }
    // other browser
    return false;
  },

  /**
   * Checks to see if we are running in a mobile browser (tablet or phone)
   * @param {String} userAgent A user agent string
   * @return {Boolean} True if there's good reason to believe we're running on a tablet or phone, otherwise false.
   */
  detectMobile: function (userAgent) {
    var isMobile = Page.isSmall() || Page.isExtraSmall();

    //we could use something like the mobile-detect library here, but 37kb seemed a bit much for how much this function
    //is being used
    if (userAgent) {
      userAgent = s(userAgent.toLowerCase());
      isMobile =
        isMobile ||
        userAgent.contains("ipad") ||
        userAgent.contains("iphone") ||
        userAgent.contains("crios") ||
        userAgent.contains("android");
    }

    return isMobile;
  },
};



//////////////////
// WEBPACK FOOTER
// ./public/js/core/utils/BrowserUtils.js
// module id = 487
// module chunks = 1